import { render, staticRenderFns } from "./SchoolActivityCalendarModal.vue?vue&type=template&id=4628aa97&scoped=true"
import script from "./SchoolActivityCalendarModal.vue?vue&type=script&lang=js"
export * from "./SchoolActivityCalendarModal.vue?vue&type=script&lang=js"
import style0 from "./SchoolActivityCalendarModal.vue?vue&type=style&index=0&id=4628aa97&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4628aa97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4628aa97')) {
      api.createRecord('4628aa97', component.options)
    } else {
      api.reload('4628aa97', component.options)
    }
    module.hot.accept("./SchoolActivityCalendarModal.vue?vue&type=template&id=4628aa97&scoped=true", function () {
      api.rerender('4628aa97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolHomeCommunication/modules/SchoolActivityCalendarModal.vue"
export default component.exports